export default __webpack_public_path__ + "static/media/CheesePizza.be1e71d7.jpg";